import { render, staticRenderFns } from "./VerticalBulletNaf.vue?vue&type=template&id=0b40ef8c&scoped=true"
import script from "./VerticalBulletNaf.vue?vue&type=script&lang=js"
export * from "./VerticalBulletNaf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b40ef8c",
  null
  
)

export default component.exports